module.exports = __webpack_public_path__ + "static/media/film.3cadcce2.svg";